module.exports = __webpack_public_path__ + "static/logos-tiles-bmw-1294d6b4321983efe2f011554fe07348.svg";